import React from "react";
import styled from "@emotion/styled";
import {css} from "@mui/material";

const disabledButtonStyle = css`
	background: rgb(61 67 75 / 50%);
	color: #848990;
`;

const HistoryButton = styled.button<Pick<IProps, "isDisabled">>`
	height: 40px;
	background: rgba(19, 68, 128, 0.5);
	font-family: var(--fontFamilyBase);
	font-size: 14px;
	line-height: 16px;
	display: flex;
	align-items: center;
	color: #58a3ff;
	justify-content: center;
	border-radius: 20px;
	border: none;
	box-shadow: none;
	font-weight: bold;
	margin: 10px auto;
	max-width: 90%;
	width: 100%;
	svg {
		margin-right: 8px;
	}

	${(props) => props.isDisabled && disabledButtonStyle}
`;

interface IProps {
	icon?: React.FunctionComponent;
	text: string;
	onClick?: () => void;
	isDisabled?: boolean;
	styleExtend?: unknown;
	isForModal?: boolean;
	withAutoFocus?: boolean;
}

export const ButtonWithIcon: React.FC<IProps> = (props) => {
	const Icon = props.icon || null;
	return (
		<HistoryButton
			as={props.styleExtend as undefined}
			onClick={props.onClick}
			isDisabled={props.isDisabled}
			aria-disabled={props.isDisabled}
			autoFocus={props.withAutoFocus}
			aria-haspopup={props.isForModal ? "dialog" : undefined}
		>
			{Icon && <Icon />}
			{props.text}
		</HistoryButton>
	);
};
